import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Branch_Contact_URL } from "../Url";
export const branchContactActions = {
  FETCH_BRANCH_CONTACT_LIST: "FETCH_BRANCH_CONTACT_LIST",
  FETCH_BRANCH_CONTACT_LIST_SUCCESS: "FETCH_BRANCH_CONTACT_LIST_SUCCESS",
  FETCH_BRANCH_CONTACT_LIST_ERROR: "FETCH_BRANCH_CONTACT_LIST_ERROR",
};

export function saveBranchContactDetails(props) {
  const { accessToken, partnerFirmId, partnerBranchId, newValues } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Contact_URL}/savePartnerBranchContactDetails?partnerFirmId=${partnerFirmId}`,
      data: newValues,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchContactDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchContactDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchContactDetailsError(err));
          return err.response;
        }
      });
}
export function getBranchContactDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: branchContactActions.FETCH_BRANCH_CONTACT_LIST_SUCCESS,
      payload: props,
    });
  };
}
export function getBranchContactDetailsError(error) {
  return {
    type: branchContactActions.FETCH_BRANCH_CONTACT_LIST_ERROR,
    payload: error,
  };
}

export const ContactActions = {
  CONTACT_LIST_SUCCESS: "FETCH_LIST_SUCCESS",
  CONTACT_LIST_ERROR: "FETCH_BRANCH_CONTACT_LIST_ERROR",
};

export function getBranchContactDetails(props) {
  const { accessToken, partnerFirmId, partnerBranchId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Contact_URL}/getPartnerBranchContactDetails?partnerBranchId=${partnerBranchId}&partnerFirmId=${partnerFirmId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getContactDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getContactDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getContactDetailsError(err));
          return err.response;
        }
      });
}

export function getContactDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: ContactActions.CONTACT_LIST_SUCCESS,
      payload: props,
    });
  };
}
export function getContactDetailsError(error) {
  return {
    type: branchContactActions.CONTACT_LIST_ERROR,
    payload: error,
  };
}
